/**
 * Tipos para o sistema de pastas de transcrições.
 * Similar ao Google Drive - suporta hierarquia de pastas infinita.
 */

/** Resposta de uma pasta do backend */
export interface TranscriptionFolder {
  id: string
  name: string
  parentFolderId: string | null
  color: string | null
  icon: string | null
  createdAt: number | null
  updatedAt: number | null
  itemCount: number | null
}

/** Resposta da listagem de pastas */
export interface FolderListResponse {
  folders: TranscriptionFolder[]
}

/** Breadcrumb (caminho da pasta) */
export interface BreadcrumbResponse {
  path: TranscriptionFolder[]
}

/** Request para criar pasta */
export interface CreateFolderRequest {
  name: string
  parentFolderId?: string | null
  color?: string | null
}

/** Request para atualizar pasta */
export interface UpdateFolderRequest {
  name?: string
  color?: string | null
  icon?: string | null
}

/** Request para mover arquivo */
export interface MoveFileRequest {
  folderId: string | null
}

/** Request para mover múltiplos arquivos */
export interface MoveFilesRequest {
  fileIds: string[]
  folderId: string | null
}

/** Cores predefinidas para pastas */
export const FOLDER_COLORS = [
  { value: '#90CAF9', label: 'Azul claro' },
  { value: '#1976d2', label: 'Azul' },
  { value: '#66BB6A', label: 'Verde' },
  { value: '#FFA726', label: 'Laranja' },
  { value: '#EF5350', label: 'Vermelho' },
  { value: '#AB47BC', label: 'Roxo' },
  { value: '#78909C', label: 'Cinza' },
  { value: '#FFD54F', label: 'Amarelo' },
  { value: '#4DB6AC', label: 'Teal' },
  { value: '#F06292', label: 'Rosa' },
] as const

/** Tipo de item para uso em drag and drop */
export type DragItemType = 'file' | 'folder'

export interface DragItem {
  type: DragItemType
  id: string
  title: string
}
